import { render } from "./NetworkMapCoordinates.vue?vue&type=template&id=11924310&scoped=true&ts=true"
import script from "./NetworkMapCoordinates.vue?vue&type=script&lang=ts"
export * from "./NetworkMapCoordinates.vue?vue&type=script&lang=ts"

import "./NetworkMapCoordinates.vue?vue&type=style&index=0&id=11924310&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\arind\\Documents\\scm\\easynwk-vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11924310"]])

export default __exports__